export const getSessionId = (): Promise<string> =>
	new Promise((resolve) => {
		window.gtag(
			'get',
			process.env.NEXT_PUBLIC_ANALYTICS_MEASUREMENT_ID,
			'session_id',
			(args: string) => resolve(args)
		)
	})
